import { Badge } from '@chakra-ui/react';
import { FC } from 'react';

export const GlobalBadge: FC = () => {
    return <Badge>Global</Badge>;
};
